<!-- Публичный -->
<div
    *ngIf="isPublic && routeData"
    class="custom-system-header justify-between mat-elevation-z3 header-block-rows"
    ngClass.sm="header-block-sm"
    ngClass.xs="header-block-xs"
>
    <div>
        <div class="header-block-container header-block-left">
            <a
                class="header-block-home"
                routerLink="/"
                title="{{
                    appService.getSettingsByKey('header_big_text') +
                        ' ' +
                        appService.getSettingsByKey('header_little_text')
                }}"
            >
                <img
                    class="header-logo"
                    *ngIf="appService.getLoginWindowLogo()"
                    alt="{{ appService.getSettingsByKey('header_big_text') }}"
                    [src]="appService.serverUrl + appService.getLoginWindowLogo()"
                />
                <span class="header-logo-text gt-sm:inline-block xs:hidden">
                    <span class="header-logo-text-title">{{ appService.getSettingsByKey('header_big_text') }}</span>
                    <span
                        class="header-logo-text-sub"
                        appShowTooltip="parent"
                        matTooltip="{{ appService.getSettingsByKey('header_little_text') }}"
                    >
                        {{ appService.getSettingsByKey('header_little_text') }}
                    </span>
                </span>
            </a>
        </div>
    </div>
    <div class="gt-sm:block xs:hidden" ngClass.sm="header-block-sm" ngClass.xs="header-block-xs">
        <ul class="menu-site">
            <li *ngFor="let item of appService.publicMenu">
                <ng-container *ngIf="item.url.startsWith('http'); else linkFront">
                    <a [href]="item.url" [target]="item.newTab ? '_blank' : '_self'">{{ item.name }}</a>
                </ng-container>
                <ng-template #linkFront>
                    <a [routerLink]="item.url">{{ item.name }}</a>
                </ng-template>
            </li>
        </ul>
    </div>
    <div ngClass.sm="header-block-sm" ngClass.xs="header-block-xs">
        <div class="header-block-container header-block-language-container" *ngIf="appService.languageCount > 1">
            <button
                mat-button
                [title]="appService.language_dictionary.system_header_change_language"
                [matMenuTriggerFor]="menuPublicLanguage"
            >
                <span class="header-language-code">{{ currentLang.lang }}</span>
            </button>
            <mat-menu #menuPublicLanguage="matMenu">
                <div *ngFor="let lang of appService?.languages | keyvalue">
                    <button
                        (click)="setCurrentLang(lang?.value)"
                        *ngIf="currentLang.lang !== lang?.value.lang"
                        mat-menu-item
                    >
                        <span>{{ lang?.value?.names[appService.defaultLanguage] }}</span>
                    </button>
                </div>
            </mat-menu>
        </div>
    </div>
    <div
        *ngIf="appService.routeData && appService.routeData.header_button"
        class="gt-sm:block xs:hidden"
        ngClass.sm="header-block-sm"
        ngClass.xs="header-block-xs"
    >
        <div class="header-block-container header-block-right">
            <fui-button
                [routerLink]="appService.routeData.header_button.link"
                [label]="appService.language_dictionary[appService.routeData.header_button.name]"
            >
            </fui-button>
        </div>
    </div>
</div>

<!-- Внутренний -->
<div
    *ngIf="!isPublic"
    class="custom-admin-header justify-between"
    ngClass.sm="header-block-sm"
    ngClass.xs="header-block-xs"
>
    <div class="ml-[8px]">
        <div class="header-block-container header-block-left">
            <a class="header-block-home" routerLink="/">
                <img
                    class="header-logo"
                    *ngIf="appService.getLoginWindowLogo()"
                    [src]="appService.serverUrl + appService.getLoginWindowLogo()"
                />
                <span class="header-logo-text gt-sm:inline-block xs:hidden">
                    <span class="header-logo-text-title">
                        <span appShowTooltip="parent" matTooltip="{{ appService.getSettingsByKey('header_big_text') }}">
                            {{ appService.getSettingsByKey('header_big_text') }}
                        </span>
                    </span>
                    <span class="header-logo-text-sub">
                        <span
                            appShowTooltip="parent"
                            matTooltip="{{ appService.getSettingsByKey('header_little_text') }}"
                        >
                            {{ appService.getSettingsByKey('header_little_text') }}
                        </span>
                    </span>
                </span>
            </a>
        </div>
    </div>
    <div class="flex">
        <div class="header-block-add-button">
            <!-- Розетка IHeaderComponent_AfterViewInit -->
            <ng-template #headerRight></ng-template>

            <button
                mat-icon-button
                [title]="appService.language_dictionary.system_header_change_language"
                [matMenuTriggerFor]="menuPublicLanguage"
                *ngIf="appService.languageCount > 1"
            >
                <span class="header-language-code">{{ currentLang.lang }}</span>
            </button>
            <!-- Языковое меню -->
            <mat-menu #menuPublicLanguage="matMenu">
                <div *ngFor="let lang of appService?.languages | keyvalue">
                    <button mat-menu-item (click)="setCurrentLang(lang?.value)" *ngIf="currentLang !== lang?.value">
                        <span>{{ lang?.value?.names[appService.defaultLanguage] }}</span>
                    </button>
                </div>
            </mat-menu>
        </div>
        <div class="menu-toggle-button-container gt-sm:hidden sm:block">
            <button
                mat-button
                class="menu-toggle-button"
                (click)="onToggleSidenav(appService.isPublic)"
                title="{{
                    openMenu
                        ? appService.language_dictionary.system_header_menu_close
                        : appService.language_dictionary.system_header_menu_open
                }}"
            >
                <mat-icon fontSet="mdi" [fontIcon]="'mdi-' + (openMenu ? 'close' : 'menu')"></mat-icon>
            </button>
        </div>
    </div>
</div>
